import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfFigmaTemplateTag } from "@swagger/typescript-fetch-goflyer";

export const useFigmaTemplateTagOptions = () => {
  const [figmaTemplateTagOptionList, setFigmaTemplateTagOptionList] =
    useState<GfFigmaTemplateTag[]>();

  const fetchFigmaTemplateTags = useCallback(async () => {
    try {
      const response =
        await adminApiService.getManyBaseGfFigmaTemplateTagAdminControllerGfFigmaTemplateTag();
      setFigmaTemplateTagOptionList(response.data);
    } catch (error) {
      console.error("Error fetching figma template tags:", error);
    }
  }, []);

  useEffect(() => {
    fetchFigmaTemplateTags();
  }, [fetchFigmaTemplateTags]);

  return { figmaTemplateTagOptionList, fetchFigmaTemplateTags };
};
